import { randomString } from '../uuid-generator'
import { database } from '../database'

/**
 * Create user
 *
 * @param {object} user
 * @param {string} user.email
 * @param {string} user.name
 * @param {string} user.surname
 * @param {string} user.company
 * @param {string|null} [user.password]
 * @param {string|null} [user.phone]
 * @return {Promise}
 */
export const createUser = user => {
    const userPassword = user.password || randomString(8)

    if (!user.email || user.email === '') {
        return new Promise(() => {
            throw 'Missing email!'
        })
    }

    return (
        database('new_user')
            .add({
                displayName: `${user.name} ${user.surname}`,
                email: user.email,
                password: userPassword,
                phoneNumber: !user.phone || user.phone === '' ? null : user.phone,
                approved: true,
                defaultPasswordChanged: false,
                name: user.name,
                surname: user.surname,
                company: !user.company || user.company === '' ? null : user.company,
            })
    )
}
